import React from 'react';
import { PL_PREQUAL_OFFER_MODULE } from 'types/morph.pagePosition.constants';
import { useSeenOfferPixel } from 'hook/helper.hook';
import { getViewOfferTileCard } from 'helpers/tracking.helpers';
import { Link } from 'components/navigation/Link/Link';
import PIcon from 'components/personalization/PIcon';

const MarketplaceOfferCard = ({ offerModulePosition, ...props }) => {
  let attributes = {
    moduleName: PL_PREQUAL_OFFER_MODULE,
    modulePosition: props.modulePosition,
    offerModulePosition: offerModulePosition,
    cardName: props.cardName,
    vertical: props.verticalTracking,
  };

  let trackingAttributes = getViewOfferTileCard(attributes);

  const seenOffer = useSeenOfferPixel(trackingAttributes);
  return (
    <div className={props.containerClasses}>
      <Link
        onClickCallback={props.onLinkClickEvent}
        datatestid="Overview-offer-carousel-link"
        to={props.url}
        location={props.location}
        extraEventAttributes={trackingAttributes}
      >
        <div className="offer-card padTB16 padLR6">
          <div className="FlexContainer flex-column justify-start items-align-center">
            <>
              <PIcon icon={props.tileIconKey} />
              {seenOffer}
            </>
            <div className="text-12 margT16 fontGray400">{props.text}</div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default MarketplaceOfferCard;
